import { useTranslation } from 'next-i18next';
import React from 'react';
import { Icon } from '@hotelplan/components.common.icon';
import { BsButtonWithIcon } from '@hotelplan/core.fusion.bs-button-with-icon';
import { FdrImage } from '@hotelplan/fdr.regular.basis.fdr-image';
import { E_BUTTON_TYPE } from '@hotelplan/style.hotelplan-style';
import { IWishlistItemProps } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist.types';
import {
  WishListImagesWrapper,
  WishlistItemsWrapper,
  WishListItemTitleWrapper,
  WishListItemWrapper,
} from './fdr-wishlist-item-desktop.styles';

export const FdrWishlistItemDesktop: React.FC<IWishlistItemProps> = props => {
  const {
    id,
    name,
    image,
    productsAmount,
    active,
    editable,
    onClick,
    onRemove,
    onEdit,
    className,
  } = props;

  const [t] = useTranslation('common');

  return (
    <WishlistItemsWrapper>
      <WishListItemWrapper
        data-id={id}
        onClick={() => onClick?.(id)}
        active={active}
        className={className}
      >
        {productsAmount !== 0 ? (
          <FdrImage
            className="wishlist-item-image"
            image={image}
            lazy={false}
          />
        ) : (
          <WishListImagesWrapper>
            <Icon className="wishlist-item-icon" name={'favorite-fill'} />
          </WishListImagesWrapper>
        )}
        <WishListItemTitleWrapper className="wishlistCheckboxTitle">
          <h3 className="wishlist-item-title">{name}</h3>
          {editable && (
            <BsButtonWithIcon
              className="wishlist-item-editable-button"
              variant={E_BUTTON_TYPE.CIRCLE_BUTTON}
              icon={{
                name: 'edit',
                size: 'sm',
              }}
              testId="edit"
              onClick={onEdit ? e => onEdit(e) : undefined}
            >
              {t('common:edit')}
            </BsButtonWithIcon>
          )}
          <span className="wishlist-item-span" />
          <span className="wishlist-item-product-amount-span">
            {productsAmount}
          </span>
        </WishListItemTitleWrapper>
        {editable && (
          <BsButtonWithIcon
            className="wishlist-item-delete-button"
            variant={E_BUTTON_TYPE.CIRCLE_BUTTON}
            icon={{
              name: 'delete',
              size: 'sm',
            }}
            testId="remove"
            aria-label={t('wishlist:remove.label', { name })}
            onClick={onRemove ? e => onRemove(e) : undefined}
          >
            {t('common:delete')}
          </BsButtonWithIcon>
        )}
      </WishListItemWrapper>
    </WishlistItemsWrapper>
  );
};
